// old key to standard key mapper
export const OLD_TO_STANDARD_TIMEZONE_MAPPER: Record<string, string> = {
  'Eastern Time (US & Canada)': 'Eastern Time - New York',
  'Indiana (East)': 'Eastern Time - Indianapolis',
  'Central Time (US & Canada)': 'Central Time - Chicago',
  'Saskatchewan': 'Central Standard Time - Regina',
  'Mountain Time (US & Canada)': 'Mountain Time - Denver',
  'Arizona': 'Mountain Standard Time - Phoenix',
  'Pacific Time (US & Canada)': 'Pacific Time - Los Angeles',
  'Alaska': 'Alaska Time - Anchorage',
  'Atlantic Time (Canada)': 'Atlantic Time - Halifax',
  'Newfoundland': 'Newfoundland Time',
  'Hawaii': 'Hawaii-Aleutian Standard Time',
};

export const DEFAULT_TIME_ZONE_IANA = 'America/Chicago';

export const LOCAL_STORAGE_KEY = 'global-support-timezone-country-code-data';
